import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Title,
  Filler,
} from "chart.js";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { Spin, Typography } from "antd";
const { Title: H3 } = Typography;

// Register chart.js components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Title,
  Filler
);

const ResultsGraph = () => {
  const [chartData, setChartData] = useState(null);

  const [resultsSuccess, resultsErrors, resultsLoading] = useAxios(
    process.env.REACT_APP_STUDENT_RESULTS_YEARLY_GRAPH_API,
    "GET",
    "GET"
  );

  useEffect(() => {
    if (resultsSuccess?.data) {
      const data = resultsSuccess.data;

      const labels = data.map((item) => item.month);
      const examAvg = data.map((item) => item.exam_avg);
      const quizAvg = data.map((item) => item.quiz_avg);
      const homeworkAvg = data.map((item) => item.homework_avg);

      setChartData({
        labels,
        datasets: [
          {
            label: "متوسط الاختبارت الشهرية",
            data: examAvg,
            borderColor: "#ef4444",
            backgroundColor: "rgba(239, 68, 68, 0.1)",
            tension: 0.4,
            fill: true,
            borderWidth: 3,
            pointRadius: 5,
            pointHoverRadius: 7,
            pointBackgroundColor: "#ef4444",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#ef4444",
            pointHoverBorderWidth: 3,
          },
          {
            label: "متوسط الامتحانات",
            data: quizAvg,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.1)",
            tension: 0.4,
            fill: true,
            borderWidth: 3,
            pointRadius: 5,
            pointHoverRadius: 7,
            pointBackgroundColor: "#3b82f6",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#3b82f6",
            pointHoverBorderWidth: 3,
          },
          {
            label: "متوسط الواجبات",
            data: homeworkAvg,
            borderColor: "#10b981",
            backgroundColor: "rgba(16, 185, 129, 0.1)",
            tension: 0.4,
            fill: true,
            borderWidth: 3,
            pointRadius: 5,
            pointHoverRadius: 7,
            pointBackgroundColor: "#10b981",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#10b981",
            pointHoverBorderWidth: 3,
          },
        ],
      });
    }
  }, [resultsSuccess]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        position: "top",
        align: "center",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          font: {
            size: 13,
            family: "'Cairo', sans-serif",
            weight: "600",
          },
          color: "#374151",
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        padding: 12,
        titleFont: {
          size: 14,
          family: "'Cairo', sans-serif",
          weight: "bold",
        },
        bodyFont: {
          size: 13,
          family: "'Cairo', sans-serif",
        },
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "rgba(255, 255, 255, 0.1)",
        borderWidth: 1,
        displayColors: true,
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.parsed.y}%`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
          font: {
            size: 12,
            family: "'Cairo', sans-serif",
          },
          color: "#6b7280",
          callback: function (value) {
            return value + "%";
          },
        },
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
          drawBorder: false,
        },
        border: {
          display: false,
        },
      },
      x: {
        ticks: {
          font: {
            size: 12,
            family: "'Cairo', sans-serif",
          },
          color: "#6b7280",
        },
        grid: {
          display: false,
          drawBorder: false,
        },
        border: {
          display: false,
        },
      },
    },
  };

  if (resultsLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  if (!chartData) return <div>لا توجد بيانات متاحة</div>;

  return (
    <div className="mt-10 rounded-2xl p-5" dir="rtl">
      <H3 level={3} className="dark:text-white">
        متوسط الأداء الشهري
      </H3>
      <div className="mt-10 border-2 border-secondary rounded-2xl p-5 bg-white shadow-sm">
        <div style={{ height: "400px" }}>
          <Line data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default ResultsGraph;
